import { Navigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getCategoryBySlug } from '@quds/shared';
import { Brand } from '@/components/layout/Brand';
import { EnvironmentBadge } from '@/components/layout/EnvironmentBadge';
import { UserMenu } from '@/components/layout/UserMenu';
import { ButtonLink } from '@/components/ui';
import { CATEGORY_ICONS } from './categoryIcons';

export function CategoryComingSoonPage() {
  const { slug = '' } = useParams();
  const category = getCategoryBySlug(slug);
  if (!category) return <Navigate to="/categories" replace />;
  if (category.moduleAvailable) return <Navigate to={`/${category.slug}`} replace />;
  const Icon = CATEGORY_ICONS[category.code];

  return (
    <div className="min-h-screen">
      <header className="flex h-topbar items-center gap-3 border-b border-line bg-surface px-4 lg:px-6">
        <Brand />
        <div className="ml-auto flex items-center gap-3">
          <EnvironmentBadge />
          <UserMenu showSettings={false} />
        </div>
      </header>
      <main className="mx-auto flex max-w-lg flex-col items-center px-4 py-20 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-primary-soft text-primary">
          <Icon size={30} aria-hidden="true" />
        </span>
        <h1 className="mt-6 text-xl font-semibold text-ink">{category.name}</h1>
        <p className="mt-2 text-sm leading-relaxed text-ink-secondary">
          Management for {category.name.toLowerCase()} is coming soon. The Central Admin Console is built to support every Quds
          business category; the {category.singular.toLowerCase()} module will be added in a future phase.
        </p>
        <ButtonLink to="/categories" className="mt-8" leftIcon={<ArrowLeft size={16} aria-hidden="true" />}>
          Back to Categories
        </ButtonLink>
      </main>
    </div>
  );
}
